import React from "react";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";

const InboxLayout = () => {
  return (
    <div className="bg-grey-100 flex  body-height overflow-auto">
      <Sidebar />
      <div className="overflow-auto w-full">
        <Outlet />
      </div>
    </div>
  );
};

export default InboxLayout;
